import {
  OutreachConfigFormFields,
  OutreachConfigSections,
  OutreachTimeFormFields,
  OutreachTriggerTypes,
  SubscriberClearMessageFormFields,
  SubscriberOutreachContentFormFields,
  SupportOutreachClearMessageFormFields,
  SupportOutreachContentFormFields,
  SupportOutreachTriggerFormFields,
} from '../../Monitor/types';
import { FrequencyUnits } from '../../Monitor/components/OutreachConfigForm/helpers';
import { OutreachConfigFormDto } from '../hooks/useOutreach';

export const getFormDefaultValues = (): OutreachConfigFormDto => {
  return {
    [OutreachConfigSections.Config]: {
      [OutreachConfigFormFields.SupportOutreach]: false,
      [OutreachConfigFormFields.SupportOutreachEnabled]: false,
      [OutreachConfigFormFields.SubscriberOutreach]: false,
      [OutreachConfigFormFields.SubscriberOutreachEnabled]: false,
      [OutreachConfigFormFields.WebhookOutreach]: false,
      [OutreachConfigFormFields.WebhookOutreachEnabled]: false,
      [OutreachConfigFormFields.SelectedWebhook]: [],
      [OutreachConfigFormFields.SelectedWebhookName]: 'Webhook',
    },

    // support
    [OutreachConfigSections.SupportOutreachTime]: {
      [OutreachTimeFormFields.From]: undefined,
      [OutreachTimeFormFields.To]: undefined,
    },
    [OutreachConfigSections.SupportOutreachTrigger]: {
      [SupportOutreachTriggerFormFields.IsOneTimeOnly]: false,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach]: undefined,
      [SupportOutreachTriggerFormFields.TriggerType]: OutreachTriggerTypes.Time,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery]: undefined,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachUnit]:
        FrequencyUnits.Hour,
      [SupportOutreachTriggerFormFields.SendClearEmailWhenIssueCleared]: false,
      [SupportOutreachTriggerFormFields.IssueClearedWhen]: undefined,
      [SupportOutreachTriggerFormFields.IssueTriggeredWhen]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatEvery]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatWeekdays]: [],
      [SupportOutreachTriggerFormFields.TimeRepeatEveryUnit]:
        FrequencyUnits.Hour,
    },
    [OutreachConfigSections.SupportOutreachContent]: {
      [SupportOutreachContentFormFields.OutreachRuleName]: '',
      [SupportOutreachContentFormFields.OutreachMethod]: true,
      [SupportOutreachContentFormFields.Recipients]: [''],
      [SupportOutreachContentFormFields.Subject]: '',
      [SupportOutreachContentFormFields.Introduction]: '',
    },
    [OutreachConfigSections.SupportOutreachClearMessage]: {
      [SupportOutreachClearMessageFormFields.Recipients]: [''],
      [SupportOutreachClearMessageFormFields.Subject]: '',
      [SupportOutreachClearMessageFormFields.Introduction]: '',
    },

    //webhook
    [OutreachConfigSections.SupportOutreachTimeWebhook]: {
      [OutreachTimeFormFields.From]: undefined,
      [OutreachTimeFormFields.To]: undefined,
    },
    [OutreachConfigSections.SupportOutreachTriggerWebhook]: {
      [SupportOutreachTriggerFormFields.IsOneTimeOnly]: false,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach]: undefined,
      [SupportOutreachTriggerFormFields.TriggerType]: OutreachTriggerTypes.Time,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery]: undefined,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachUnit]:
        FrequencyUnits.Hour,
      [SupportOutreachTriggerFormFields.SendClearEmailWhenIssueCleared]: false,
      [SupportOutreachTriggerFormFields.IssueClearedWhen]: undefined,
      [SupportOutreachTriggerFormFields.IssueTriggeredWhen]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatEvery]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatWeekdays]: [],
      [SupportOutreachTriggerFormFields.TimeRepeatEveryUnit]:
        FrequencyUnits.Hour,
    },

    // subscriber
    [OutreachConfigSections.SubscriberOutreachTime]: {
      [OutreachTimeFormFields.From]: undefined,
      [OutreachTimeFormFields.To]: undefined,
    },
    [OutreachConfigSections.SubscriberOutreachTrigger]: {
      [SupportOutreachTriggerFormFields.IsOneTimeOnly]: false,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreach]: undefined,
      [SupportOutreachTriggerFormFields.TriggerType]: OutreachTriggerTypes.Time,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachEvery]: undefined,
      [SupportOutreachTriggerFormFields.ScheduleMaxFrequencyOfSupportOutreachUnit]:
        FrequencyUnits.Hour,
      [SupportOutreachTriggerFormFields.SendClearEmailWhenIssueCleared]: false,
      [SupportOutreachTriggerFormFields.IssueClearedWhen]: undefined,
      [SupportOutreachTriggerFormFields.IssueTriggeredWhen]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatEvery]: undefined,
      [SupportOutreachTriggerFormFields.TimeRepeatWeekdays]: [],
      [SupportOutreachTriggerFormFields.TimeRepeatEveryUnit]:
        FrequencyUnits.Hour,
    },
    [OutreachConfigSections.SubscriberOutreachContent]: {
      [SubscriberOutreachContentFormFields.OutreachRuleName]: '',
      [SubscriberOutreachContentFormFields.Subject]: '',
      [SubscriberOutreachContentFormFields.Message]: '',
      [SubscriberOutreachContentFormFields.UrlEnabled]: false,
      [SubscriberOutreachContentFormFields.LinkReference]: '',
      [SubscriberOutreachContentFormFields.UrlText]: '',
      [SubscriberOutreachContentFormFields.UrlLink]: '',
    },
    [OutreachConfigSections.SubscriberOutreachClearMessage]: {
      [SubscriberClearMessageFormFields.Subject]: '',
      [SubscriberClearMessageFormFields.Message]: '',
    },
  };
};
